import { Controller } from '@hotwired/stimulus'
import TcAdapter from "tcadapter";

export default class extends Controller {
  static values = {
    fileId: String,
    appid: String,
    psign: String
  }
  connect() {
    const isSupported = TcAdapter.isSupported();

    // alert(isSupported)
    // document.getElementById("result").innerHTML = isSupported;

    const self = this
     console.log("video js", isSupported,  "fileid", this.fileIdValue, "appid",this.appidValue, "psing", this.psignValue);
    this.adapter = new TcAdapter(this.element, {
      fileID: self.fileIdValue,
      appID: self.appidValue,
      psign: self.psignValue,
      hlsConfig: {
        maxBufferSize: 1 * 1024 * 1024,
      }
    }, () => {
      console.log('basicInfo', this.adapter.getVideoBasicInfo());
    });

    this.adapter.on(TcAdapter.TcAdapterEvents.HLSREADY, () => {
      const hls = this.adapter.hls;
      console.log(hls, this.adapter.getStreamimgOutputList());
            // ...
    })
  }
}
